/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Default_Next_TaskInputs */

const en_task_flow_default_next_task = /** @type {(inputs: Task_Flow_Default_Next_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default next activity`)
};

const pt_br2_task_flow_default_next_task = /** @type {(inputs: Task_Flow_Default_Next_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima atividade padrão`)
};

/**
* | output |
* | --- |
* | "Default next activity" |
*
* @param {Task_Flow_Default_Next_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_default_next_task = /** @type {((inputs?: Task_Flow_Default_Next_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Default_Next_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_default_next_task(inputs)
	return pt_br2_task_flow_default_next_task(inputs)
});